import { PAGE_META } from "@/config/page-meta";
import { CreateCredentialForm } from "@/features/credentials/components/create-credential-form";
import { useCredentialEditParams } from "@/features/credentials/pages/edit/hooks/use-credential-edit-params";
import { getEditCredentialSheetBack } from "@/features/credentials/pages/edit/lib/get-edit-credential-sheet-back";
import { useCredentialsListQuery } from "@/features/credentials/queries/use-credentials-list";
import { usePageMeta } from "@/hooks/use-page-meta";
import { Button, RouteSheet } from "@cmde/shadcn";
import { Loader2Icon } from "lucide-react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export default function EditCredentialSheetPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { customerId, organizationId, sport, credentialId } = useCredentialEditParams();
  const credentialsListQuery = useCredentialsListQuery({ sport, organizationId });

  const credential = credentialsListQuery.data?.find(
    (item) => String(item.credentialId) === String(credentialId),
  );

  const closeSheet = () => {
    navigate(getEditCredentialSheetBack({ customerId, organizationId, sport }));
  };

  return (
    <>
      {usePageMeta(PAGE_META.credentialsEdit)}
      <RouteSheet
        title={
          credential
            ? t("credentials.edit.title")
            : t("credentials.edit.not_found_title")
        }
        size="xl"
        onClose={closeSheet}
      >
        <div className="px-6 pb-6">
          {credentialsListQuery.isLoading ? (
            <div className="text-muted-foreground flex items-center gap-2 text-sm">
              <Loader2Icon className="size-4 animate-spin" />
            </div>
          ) : credential ? (
            <CreateCredentialForm
              mode="edit"
              sport={sport}
              organizationId={organizationId}
              credential={credential}
              onCancel={closeSheet}
              onSuccess={closeSheet}
            />
          ) : (
            <div className="flex flex-col gap-4">
              <p className="text-muted-foreground text-sm">{t("credentials.edit.not_found_description")}</p>
              <div className="flex justify-end">
                <Button type="button" variant="outline" onClick={closeSheet}>
                  {t("credentials.edit.cancel")}
                </Button>
              </div>
            </div>
          )}
        </div>
      </RouteSheet>
    </>
  );
}
